const clientSetup = () => {
  // do nothing, client can deal with it on its own
};

export const errorSetup = clientSetup;
